// Core
import React from 'react'

// Components, services, constants
import Card from 'components/Card'
import FlatList from 'components/FlatList'
import LabelValuePair from 'components/LabelValuePair'

// 3rd party
import classnames from 'classnames'
import styled from 'styled-components/macro'

type Props = {
  className?: string
  selectorData: any
}

const AdditionalDetailsCard = ({className, selectorData}: Props) => {
  const {overviewPool, heatingCooling, garage, fireplace, levels} = selectorData

  const additionalDetailsData = [
    {
      key: 'heatingCooling',
      content: <LabelValuePair label='Heating / Cooling' value={heatingCooling} />
    },
    {
      key: 'fireplace',
      content: <LabelValuePair label='Fireplace' value={fireplace} />
    },
    {
      key: 'garage',
      content: <LabelValuePair label='Garage' value={garage} />
    },
    {
      key: 'pool',
      content: <LabelValuePair label='Pool' value={overviewPool} />
    },
    {
      key: 'levels',
      content: <LabelValuePair label='Levels' value={levels} />
    }
  ]

  return (
    <AdditionalDetailsCard.Styled className={classnames('additional-details-card', className)}>
      <h3 className='title'>Additional Details</h3>
      <FlatList className='order-details' items={additionalDetailsData} withDividers />
    </AdditionalDetailsCard.Styled>
  )
}

AdditionalDetailsCard.Styled = styled(Card)`
  flex-grow: 1;
  flex-basis: 50%;
  margin-left: 30px;
`

export default AdditionalDetailsCard
